export default "//static.tradera.net/touchweb/static/output/images/category-garden-plants.6049ba01.svg";